import * as React from 'react';
import { SVGProps } from 'react';

const IconConnectionSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m5.503 8.86.273-.272a1.996 1.996 0 0 1 1.565-.571 1.992 1.992 0 0 0 1.45.806l.036.05-.002-.048a1.995 1.995 0 0 0 1.539-.582l2.828-2.829a2 2 0 0 0-2.828-2.828L9.038 3.912a5.508 5.508 0 0 0-2.369-.46l2.28-2.28a4 4 0 0 1 5.658 5.656l-2.829 2.829a4 4 0 0 1-6.275-.796z" />
    <path d="M1.172 8.95a4 4 0 0 0 5.656 5.657l2.28-2.28a5.506 5.506 0 0 1-2.368-.46l-1.326 1.325a2 2 0 0 1-2.828-2.828l2.828-2.828a1.995 1.995 0 0 1 1.54-.582 2.049 2.049 0 0 1-.003-.048l.036.05a1.992 1.992 0 0 1 1.45.806 1.995 1.995 0 0 0 1.57-.577l.268-.267A4 4 0 0 0 4 6.122L1.172 8.95z" />
  </svg>
);
export default IconConnectionSizeS;
